import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "components/CustomTable";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import { CurrencyFlags } from "constants/constants";
import { getAgentExchangeRateRequestAction } from "redux/actions/agentActions";
import { getWalletBalancesRequestAction } from "redux/actions/walletActions";
// --------------------------------------------------------------------------------
const WalletBalances = () => {
  const dispatch = useDispatch();

  const { agentExchangeRate, walletBalances } = useSelector((state) => ({
    agentExchangeRate: state.agent.agentExchangeRate,
    walletBalances: state.wallet.walletBalances,
  }));

  useEffect(() => {
    dispatch(getWalletBalancesRequestAction());
    dispatch(getAgentExchangeRateRequestAction());
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "currency",
        header: "Wallet",
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src={CurrencyFlags[row.original.currency]}
              sx={{ width: 25, height: 25 }}
            />
            <Typography sx={{ ml: 1 }}>{row.original.currency}</Typography>
          </Box>
        ),
      },
      {
        accessorKey: "balance",
        header: "Balance",
      },
      {
        accessorKey: "minimum_blance",
        header: "Minimum Balance",
      },
    ],
    []
  );

  return (
    <>
      <Grid container spacing={2}>
        {agentExchangeRate.map((rate) => (
          <Grid item xs={12} md={4}>
            <Card sx={{ borderRadius: 0 }}>
              <CardHeader title={rate.currency} />
              <CardContent>
                <Typography
                  sx={{
                    display: "inline-block",
                    fontWeight: 500,
                    fontSize: 24,
                  }}
                >
                  {rate.amount}
                </Typography>{" "}
                IRR
              </CardContent>
            </Card>
          </Grid>
        ))}
        <Grid item xs={12}>
          <CustomTable
            label="Wallets"
            data={walletBalances}
            columns={columns}
            manualPagination={false}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default WalletBalances;
